import { AfterContentInit, Component, ContentChildren, forwardRef, Input, QueryList, ViewChild } from '@angular/core'
import { MatColumnDef, MatHeaderRowDef, MatRowDef, MatTable, MatFooterRowDef } from '@angular/material/table'
import { DataSource } from '@angular/cdk/collections'
import { CdkColumnDef } from '@angular/cdk/table'

@Component({
  selector: 'lin-table-upd',
  templateUrl: './table-upd.component.html',
  styleUrls: ['./table-upd.component.scss'],
  providers: [
    {
      provide: MatTable,
      useExisting: forwardRef(() => TableUpdComponent),
    },
  ],
  standalone: false,
})
export class TableUpdComponent<T> implements AfterContentInit {
  @ContentChildren(MatHeaderRowDef) headerRowDefs: QueryList<MatHeaderRowDef>
  @ContentChildren(MatRowDef) rowDefs: QueryList<MatRowDef<T>>
  @ContentChildren(MatFooterRowDef) footerRowDefs: QueryList<MatFooterRowDef>
  @ContentChildren(MatColumnDef) columnDefs: QueryList<MatColumnDef>

  @ViewChild(MatTable, { static: true }) table: MatTable<T>

  @Input() dataSource: DataSource<T> | T[] = []

  ngAfterContentInit() {
    this.columnDefs.forEach((columnDef) => this.table.addColumnDef(columnDef))
    this.rowDefs.forEach((rowDef) => this.table.addRowDef(rowDef))
    this.headerRowDefs.forEach((headerRowDef) => this.table.addHeaderRowDef(headerRowDef))
    this.footerRowDefs.forEach((footerRowDef) => this.table.addFooterRowDef(footerRowDef))
  }

  addColumnDef(columnDef: CdkColumnDef) {
    this.table.addColumnDef(columnDef)
  }

  removeColumnDef(columnDef: CdkColumnDef) {
    this.table.removeColumnDef(columnDef)
  }
}
